module.exports = __webpack_public_path__ + "img/la-cite.8fa0822b.jpg";